import React from "react";
import Drawer from "./Drawer.jsx/Drawer";
import Header from "./Header/Header";
import { useSelector } from "react-redux";
import LoginView from "../../Views/LoginView";
import { Navigate, useLocation } from "react-router-dom";
import "./Layout.css";
import ViewWrapper from "../../Utils/ViewWrapper/ViewWrapper";

const Layout = ({ children }) => {
  const token = localStorage.getItem("token");
  const userData = useSelector((state) => state.userReducer);
  const auth = token && userData.user;
  const location = useLocation();

  const publicRoutes = ["/mot-de-passe-oublie", "/mot-de-passe-oublie/reset"];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  return (
    <ViewWrapper loading={userData.userLoading && token}>
      {auth ? (
        <div>
          <Header />
          <div className="d-flex gap-4">
            <Drawer />
            <div className="layoutApp ps-4 pb-5">{children}</div>
          </div>
        </div>
      ) : isPublicRoute ? (
        children
      ) : (
        <>
          {!token ? <Navigate to="/" /> : null}
          <LoginView />
        </>
      )}
    </ViewWrapper>
  );
};

export default Layout;
